import React from 'react';
import styles from '../../styles/Accordion.module.scss';

export default function reviewSuccess() {
  const queryParams = new URLSearchParams(window.location.search);
  const success = queryParams.get('key');
  const text =
    success === '0'
      ? 'Thank you for your review!'
      : 'Your feedback has been successfully submitted. Thank you for helping us improve our services!';
  const handleExitPage = () => {
    window.location = 'https://www.justdial.com';
  };
  return (
    <div>
      <header className={`${styles.header_box} ${styles.header_blue}`}>
        <div className={`${styles.header_left}`}>
          <div
            onClick={handleExitPage}
            onKeyDown={handleExitPage}
            className={`csicon ${styles.page_whiteback_icon} `}
            id="headerback"
            role="button"
            label="back-icon"
            tabIndex={0}
          />
        </div>
        <div className={`${styles.header_center}`}>
          <div className={`${styles.header_text} text_center`}>
            <div className="font14 fw600 colorFFF text-center">Justdial Support Review</div>
          </div>
        </div>
      </header>
      {(success === '0' || success === '3') && (
        <>
          <div className="pl-20 pr-20 mb30 tcenter" style={{ paddingTop: '100px' }}>
            <div className="wr_thumb_border">
              <div className="wr_thumb_round" />
              <img
                src="https://akam.cdn.jdmagicbox.com/images/icontent/newwap/newprot_w/wr_thumbthanks_icon.svg"
                alt=""
              />
            </div>
            <div className="wr_thanks_minus">
              <div className="mb5 font14 clrfff wr_thanks_gradient">{text}</div>
            </div>
          </div>
          <div className="wr_divider mb30" />
        </>
      )}
      {success === '1' && (
        <div className="row" style={{ paddingLeft: '20px' }}>
          <div className="col-md-12">
            <div className="error-template">
              <h1>Oops!</h1>
              <div className="error-details">Sorry, The link has expired!</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
